"use client"

// The mailbox surface's client half (docs/30 §5, H4): binds the surface-owned
// desk view and loading widget into the shared host island. The mailbox
// reading pane never triggers the legacy initial-subs load (doc 23 §22.3:
// it makes no load_more_subs request; folder routes make their own targeted
// section request), so the msg-route initial load is disabled here.
import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { MailboxMsgPage } from './deskUi/MailboxMsgPage'
import { MsgDeskLoading } from '@/mailboxDesk/MsgDeskLoading'

export default function MailboxSurfaceClient(props: DeskSurfaceClientProps) {
  return (
    <MsgDeskSurfaceClient
      {...props}
      RoutedPage={MailboxMsgPage}
      Loading={MsgDeskLoading}
      loadInitialSubsOnMsgRoute={false}
    />
  )
}
